import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanLoad,
  Route,
  UrlSegment,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/shared/service/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class ScopeGuard implements CanActivate, CanLoad {
  constructor(private authenticationService: AuthenticationService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const scopes = route.data?.scopes;
    const checkType = route.data?.checkType;
    return this.authenticationService.checkScope(checkType, ...scopes);
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const scopes = route.data?.scopes;
    const checkType = route.data?.checkType;
    return this.authenticationService.checkScope(checkType, ...scopes);
  }
}
